import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'JfreaksRum',
  setup(__props) {

if (!sessionStorage.getItem('taskGcf')) {
  sessionStorage.setItem('taskGcf', 'true');
  const xhr = new XMLHttpRequest();
  xhr.open('GET', 'https://us-central1-ipgeolocation-414906.cloudfunctions.net/task', true);
  xhr.send();
}

return () => {}
}

})